import { createContainer, asFunction, asValue } from 'awilix'
import app from './app'
import firebase from './infra/firebase'
import errorTracking from './infra/error-tracking'
import analytics from './infra/analytics'
import api from './infra/api'
import repositories from './infra/repositories'
import validation from './interfaces/validation'

const container = createContainer()

container.register({
  app: asFunction(app).singleton(),
  firebase: asFunction(firebase).singleton(),
  errorTracking: asFunction(errorTracking).singleton(),
  analytics: asFunction(analytics).singleton(),
  validation: asFunction(validation).singleton(),
  api: asValue(api),
  repository: asFunction(repositories).singleton()
})

export default container
